module.exports = __webpack_public_path__ + "img/nature-77.1f739d47.jpg";